/** "today", "yesterday", "4d ago", "2w ago", "3mo ago", "1y ago". */
export function relativeTime(t: number, now = Date.now()): string {
  const day = 86_400_000;
  const startOf = (x: number) => Math.floor(x / day);
  const days = startOf(now) - startOf(t);
  if (days <= 0) return "today";
  if (days === 1) return "yesterday";
  if (days < 7) return `${days}d ago`;
  if (days < 30) return `${Math.floor(days / 7)}w ago`;
  if (days < 365) return `${Math.floor(days / 30)}mo ago`;
  return `${Math.floor(days / 365)}y ago`;
}
